import styled from 'styled-components';

export const ResendHint = styled.div`
  display: flex;
  gap: 8px;
  margin: 0 auto 16px;
`;

export const Counter = styled.div`
  color: var(--v3-text-color);
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;
`;
